import { getUrl } from "../getUrl";

export async function sendVerifyEmail(
  email: string,
  language: string,
): Promise<Response> {
  return await fetch(getUrl("/v1/verify_email"), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email, language_code: language }),
  });
}
